// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__IbuHv","spinner-c7wet2":"Spinner_spinner-c7wet2__F4zjf","white":"Spinner_white__RhuHI"};